module.exports = __webpack_public_path__ + "img/gmoScrn2.d0c8be8b.png";